export default __webpack_public_path__ + "assets/viewer.67317ff4670df972a95b7f8fb39670d3.png";